import axios from 'axios'
import Vue from 'vue'
import { Message } from 'element-ui'

Vue.component(Message)

// let api = window.location.href.indexOf('8081') >= 0 ? '/api' : ''
const env = process.env.NODE_ENV
const api = env === 'development' ? '/api' : ''

export const getCollageData = (key) => {
  const url = `${api}/index/Resume/getUniversity`
  return axios.get(url, {
    params: {
      keyword: key
    }
  }).then(res => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
    Message({
      type: 'error',
      message: '网络错误，请稍后再试'
    })
  })
}

export const getNativePlaceList = (key) => {
  const url = `${api}/index/resume/getNativeplace`

  return axios.get(url, {
    params: {
      keyword: key
    }
  }).then(res => {
    return Promise.resolve(res.data)
  })
  .catch(err => {
    console.log(err)
    Message({
      type: 'error',
      message: '网络错误，请稍后再试'
    })
  })
}

//获取验证码
export const getchecksms = (phone, areacode) => {
  const url = `${api}/index/resume/sendVercode`
  return axios.get(url, {
    params: {
      phone:phone,
      areacode: areacode
    }
  }).then(res => {
    return Promise.resolve(res.data)
  })
  .catch(err => {
    console.log(err)
    Message({
      type: 'error',
      message: '网络错误，请稍后再试'
    })
  })
}





// WEBPACK FOOTER //
// ./src/api/search.js